import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Catering } from './pages/Catering';
import { RequestPage } from './pages/RequestPage';
import { About } from './pages/About';
import { Guide } from './pages/Guide';
import { CityGuide } from './pages/CityGuide';
import { Shop } from './pages/Shop';
import { ShopCheckout } from './pages/ShopCheckout';
import { Discover } from './pages/Discover';
import { PlacePage } from './pages/PlacePage';
import { Join } from './pages/Join';
import { Admin } from './pages/Admin';
import { ContentProvider } from './ContentContext';
import { PlatformProvider } from './contexts/PlatformContext';
import { CartProvider } from './CartContext';
import { ShopProvider } from './ShopContext';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <ContentProvider data-id="element-0" data-mp="3mkhnnxl3da7m">
      <PlatformProvider data-id="element-1" data-mp="3mjq1tehaqquj">
      <CartProvider data-id="element-2" data-mp="3mj6j3vjtnyfg">
        <ShopProvider data-id="element-3" data-mp="3rcj2nr9n9f1c">
          <BrowserRouter data-id="element-4" data-mp="3rdas0kcnegj6">
            <ScrollToTop data-id="element-5" data-mp="3rd1all5o5hp3" />
            <div className="flex min-h-screen w-full flex-col bg-papper text-black" data-id="element-6" data-mp="5yk6vxnnffx">
              <Header data-id="element-7" data-mp="82j0zgp5o9c" />
              <main className="flex-1" data-id="element-8" data-mp="2zld0l5ad579f">
                <Routes data-id="element-9" data-mp="2zmeo498kfm81">
                  <Route path="/" element={<Home data-id="element-11" data-mp="33mowttnqsqql" />} data-id="element-10" data-mp="2zn6actg9w7ln" />
                  <Route path="/catering" element={<Catering data-id="element-13" data-mp="33mym1f0yqtv8" />} data-id="element-12" data-mp="33lx0ggmbmoz9" />
                  <Route path="/forfragan" element={<RequestPage data-id="element-15" data-mp="38li619vzxvky" />} data-id="element-14" data-mp="38lrqkhy9vaj9" />
                  <Route path="/om" element={<About data-id="element-17" data-mp="3dkuws5pznmst" />} data-id="element-16" data-mp="38kglmet3bwqk" />
                  <Route path="/guide" element={<Guide data-id="element-19" data-mp="3dmfpdpsqsvo1" />} data-id="element-18" data-mp="3dl4kfmnk9hvc" />
                  <Route path="/guide/:city" element={<CityGuide data-id="element-21" data-mp="nwc0xqashrv7" />} data-id="element-20" data-mp="3dii6n5a2u64o" />
                  <Route path="/butik" element={<Shop data-id="element-23" data-mp="suncc5gqgafj" />} data-id="element-22" data-mp="nvaqno1ll9ej" />
                  <Route path="/kassa" element={<ShopCheckout data-id="element-25" data-mp="st2h0dmlgngm" />} data-id="element-24" data-mp="stuejtzr4v9j" />
                  <Route path="/upptack" element={<Discover data-id="element-27" data-mp="35ozexlizgwa" />} data-id="element-26" data-mp="36hwt7ylgu1r" />
                  <Route path="/plats/:slug" element={<PlacePage data-id="element-29" data-mp="3uct4vo20uv2l" />} data-id="element-28" data-mp="34x29ica5b3w" />
                  <Route path="/bli-en-del" element={<Join data-id="element-31" data-mp="3ucjdpx58qhvb" />} data-id="element-30" data-mp="3udkqq75thefo" />
                  <Route path="/admin" element={<Admin data-id="element-33" data-mp="d4xr1jsx4jfh" />} data-id="element-32" data-mp="d4nvlgp3tk2e" />
                </Routes>
              </main>
              <Footer data-id="element-34" data-mp="85ui3o9tht28" />
            </div>
          </BrowserRouter>
        </ShopProvider>
      </CartProvider>
      </PlatformProvider>
    </ContentProvider>;
}